import { ResponseError } from "@formant/core/common/ResponseError";

/**
 * What to tell the user when saving a view answers 409. A name collision
 * carries no field errors; any other conflict (a second org-level view)
 * explains itself in validationErrors.
 */
export function viewConflictMessage(
    error: ResponseError,
    nameConflictMessage: string,
): string {
    const messages = Object.values(error.validationErrors).flat();
    return messages.length > 0 ? messages.join(". ") : nameConflictMessage;
}
